/**
 * Print asset helpers.
 */

/**
 * The image URL to show for a print asset in selection UIs: the lightweight
 * preview when available, the full asset image otherwise. Card element
 * configurations always reference the full asset image directly — never use
 * this for the card canvas itself.
 *
 * @param {?Object} printAsset The print asset.
 * @returns {?string}
 */
export const getPrintAssetDisplayImageUrl = printAsset =>
  printAsset?.preview_asset_image?.url ?? printAsset?.asset_image?.url ?? null;

// SYSTEM print asset names carry their orientation by convention:
// "Smoke — Red (Landscape)".
const PRINT_ASSET_ORIENTATION_SUFFIX = /\s*\((Portrait|Landscape)\)\s*$/;

/**
 * The orientation encoded in a print asset's name.
 *
 * @param {?Object} printAsset The print asset.
 * @returns {?string} An ORIENTATION value, or null when not encoded.
 */
export const getPrintAssetOrientation = printAsset => {
  const match = (printAsset?.name ?? '').match(PRINT_ASSET_ORIENTATION_SUFFIX);

  return match ? match[1].toUpperCase() : null;
};
